import { FieldSet } from "client/lib/apt-merchant";
import hasInstoreChannel from "client/utils/hasInstoreChannel";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class ContactlessPaymentField extends Field<string> {
  constructor(
    model: Merchant,
    fieldSet: FieldSet<any>,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(
      model,
      {
        dataType: "string",
        testValue: "Yes",
        propertyName: "contactlessPayment",
        uiFieldType: "Select",
        ...opts,
      },
      fieldSet
    );
  }

  get applicable(): boolean {
    const salesChannel = this._model.storeDetails.salesChannel.value;

    return hasInstoreChannel(salesChannel);
  }

  get pickList(): string[] {
    return ["Yes", "No"];
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
